import * as THREE from 'three'
import Experience from './Experience'
import { ProbeControls } from './Utils/ProbeControls'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
// import { TrackballControls } from './Utils/TrackballControls'
// import { FlyControls } from './Utils/FlyControls'
// import { ToggleControls } from './Utils/ToggleControls'

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.time = this.experience.time

        this.setInstance()
        this.controls = new ProbeControls(this.instance, this.canvas)
    }

    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.001, 10)
        this.instance.position.set(1, 1, 1)
        this.scene.add(this.instance)
    }

    setRaycaster()
    {
        this.raycaster = new THREE.Raycaster()
        this.raycaster.setFromCamera(this.mouse.ndcPosition, this.instance)
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        if (this.controls) this.controls.update()
        if (this.raycaster) this.raycaster.setFromCamera(this.mouse.ndcPosition, this.instance)
    }

    destroy() 
    {
        this.scene.remove(this.instance)

        if (this.orbit) 
        {
            this.orbit.dispose()
            this.orbit = null
        }

        if (this.trackball) 
        {
            this.trackball.dispose()
            this.trackball = null
        }

        if (this.raycaster)
        {
            this.raycaster = null
        }

        if (this.instance) 
        {
            this.instance = null
        }

        this.experience = null
        this.sizes = null
        this.scene = null
        this.canvas = null

        console.log('Camera destroyed')
    }
}


